import Button from 'partial/components/Button';
import React from 'react';
import { useParams } from 'react-router-dom';
import { AiOutlinePlus } from 'react-icons/ai';
import { BsPencil } from 'react-icons/bs';
import emptyPage from 'assets/images/icons/empty-page.svg';
import { isEmpty } from 'lodash';
import { sanitizer } from 'helper';
import { Scrollbars } from 'react-custom-scrollbars-2';

import { useContentList, useShowCategory } from '../hooks';
import { useOpenContentSetup } from '../modals/ContentSetup';

// const singles = ["terms-and-conditions", "privacy-policy"]

export const EmptyPlaceholder = () => (
  <div className="h-full flex justify-center items-center text-gray-500">
    <div className="flex flex-col items-center">
      <img src={emptyPage} alt="empty" className="mb-4" />
      <div className="font-bold">Empty</div>
      <div>There are no items.</div>
    </div>
  </div>
);

export default function ContentDetails() {
  const { categoryId } = useParams();
  const [, data] = useShowCategory(categoryId);
  const [, contents] = useContentList(categoryId, {});
  const openContentSetup = useOpenContentSetup();
  const isAdd = isEmpty(contents);

  return (
    <div className="flex flex-col px-6 gap-y-6 w-full overflow-x-auto">
      <div className="flex justify-between items-center py-2 border-b border-gray-100/50">
        <div className="text-lg text-gray-800 font-bold uppercase">
          {data?.name}
        </div>
        <Button
          primary
          className="!px-4"
          size="sm"
          icon={isAdd ? AiOutlinePlus : BsPencil}
          onClick={() =>
            openContentSetup({
              type: isAdd ? 'add' : 'edit',
              category: data,
              contents: isAdd ? {} : contents,
            })
          }
        >
          {isAdd ? 'ADD' : 'EDIT'}
        </Button>
      </div>
      <div className="flex-1">
        <div className="h-full">
          <div className="flex flex-col justify-between h-full">
            {isEmpty(contents) ? (
              <EmptyPlaceholder />
            ) : (
              <div className="space-y-4">
                {contents.map((content) => (
                  <div className="border border-gray-100 rounded py-3">
                    <Scrollbars className="!h-[620px] cms-content">
                      <div
                        className="!px-4 "
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                          __html: sanitizer(content?.body),
                        }}
                      />
                    </Scrollbars>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
